import React from "react";
import { ThemeProvider } from "@mui/material";
import { themeCreator } from "./base";
import ThemeCssVarsInjector from "./ThemeCssVarsInjector";
type ThemeProps = {
  children?: React.ReactNode;
};

const ThemeProviderWrapper: React.FC<ThemeProps> = (props) => {
  const currentTheme = "PureLightTheme";
  const theme = themeCreator(currentTheme);
  return (
    <ThemeProvider theme={theme}>
      <ThemeCssVarsInjector />
      {props.children}
    </ThemeProvider>
  );
};

export default ThemeProviderWrapper;
